import { Box, Skeleton, Theme, Typography } from '@mui/material'
import React from 'react'
import { useHistory } from 'react-router';
import { checkImageExists } from '../../../utils/utilityFunctions';

export default function PopularFundsCard({ data, clientCode }: { data: any, clientCode: string }): JSX.Element {
    const history = useHistory();
    const { pathname: pathName } = history.location;
    const amcIds = ['BDOTR', 'BPIAMC']
    const checkAmcId = amcIds.includes(data?.company ?? '') ? data?.company?.toLowerCase() : data?.company;
    return (
        <Box sx={(theme: Theme) => (
            {
                padding: { xs: '11px', sm: '10px' },
                borderRadius: { xs: '10px', sm: '15px' },
                border: `1px solid ${theme.palette.grey[100]}`,
                height: { xs: '95px', sm: '140px' },
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                width: '100%',
                gap: { xs: '5px', sm: '0px' },
                '&:hover': {
                    backgroundColor: theme.palette.primary[100],
                    border: `1px solid ${theme.palette.primary[100]}`,
                }
            }
        )}
            // onClick={() => history.push(`${pathName}/${data?.scheme}`, { selectedSchemes: [data], clientCode: clientCode })}
            onClick={() => history.push(`${pathName}/${data?.scheme}`, { selectedSchemes: [data], clientCode: clientCode })}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Box>
                    <img
                        src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`}
                        alt={data?.company}
                        width={25}
                        height={25}
                        style={{
                            objectFit: "contain",
                            borderRadius: "5px",
                            alignSelf: 'flex-start',
                        }}
                    />
                </Box>
                <Typography
                    variant="overline_400"
                    sx={{
                        fontWeight: { xs: "500", sm: "600" }
                    }} >
                    {/* {data?.securityName ?? "-"} */}
                    {data?.schemeName ?? "-"}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '2px', sm: '5px' }, mt: 0.05 }}>
                <Typography variant='body_500'>
                    {Number.isFinite(Number(data?.year3Return)) ? Number(data?.year3Return).toFixed(2) + "%" : "-"}
                </Typography>
                <Typography variant='body_500' color={'text.secondary'}>
                    (3Y)
                </Typography>
            </Box>
        </Box>
    )
}
